/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';

const InstallExtensionStyles = css`
  .study-layout-content {
    display: flex;
    flex-direction: column;
    padding: 10px 40px 30px 40px;

    .checking-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .loading-image {
        margin: 20px 0;
      }
    }

    .content {
      display: flex;
      flex-direction: column;

      button {
        margin: 30px auto;
      }

      .secured-container {
        display: flex;
        justify-content: space-between;
        margin-top: 50px;

        > * {
          display: inline-block;
          margin: 4px;
        }
      }
    }
  }

  h2 {
    text-align: center
  }

  hr {
    background: #ddd;
    color: #ddd;
    clear: both;
    float: none;
    width: 100%;
    height: 1px
    color: #EBEBEB;
    background-color: #EBEBEB;
    margin-bottom: 24px;
    border: none;
  }
`;

export default InstallExtensionStyles;
